import { I18nStore } from '@tools/i18n/store';
import { TryMLLinkKeys } from '@tools/routes';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link, LinkProps, useLocation } from 'react-router';

interface DefaultLinkProps extends Omit<Partial<LinkProps>, 'to'> {
    page?: TryMLLinkKeys;
    keepQuery?: boolean;
}

const useLinkPath = (page?: TryMLLinkKeys, keepQuery?: boolean) => {
    const location = useLocation();
    const { country } = injectTSDI(I18nStore);

    let pathname = `/${country?.toLowerCase()}`;
    if (page !== 'signup') {
        pathname += `/${page}`;
    }

    return {
        pathname,
        ...(keepQuery && {
            search: location.search,
            hash: location.hash
        })
    };
};

export const DefaultLink = observer((props: DefaultLinkProps) => {
    const { children, page, keepQuery, ...rest } = props;

    const pathObject = useLinkPath(page, keepQuery);

    return (
        <Link to={pathObject} {...rest}>
            {children}
        </Link>
    );
});
